export const OBJECT_SUMMARY = 'object_summary';
export const COMPANY_NEWS = 'news';
export const COMPANY_TECH = 'company_tech';
export const COMMUNICATION_SUMMARY = 'communication_summary';